<template>
    <div :class="['modal-container',{ active: isActive }]">
        <!--agregar clas "active" para mostrarlo  <div class="modal-container active">-->
        <div class="card head-card news oDatosCard">
          <div class="title-card">
            <h4>Guardar como...</h4>
            <button class="touchpad" @click="() => { closeModal()}">x</button>
          </div>
          <div class="card-content">
            <div class="item">
              <div class="card secondary">
                <p class="paragraph dark">Escriba el nombre del archivo</p>
                <input type="text" class="fName" placeholder="Nombre del archivo" v-model="fName" @keyup.13="exportCSV" />
                  <div class="checkbox noPadding">
                    <label class="active" style="padding-left:20px">
                      <div class="user-avatar">
                        <div class="data-avatar">Incluir resumen y transcripción</div>
                      </div>
                          <input class="box" type="checkbox" v-model="resumen" @click="() => { resumen = !resumen }" />
                            <span class="nbox checkElement" style="left:0!important">
                              <svg viewBox="0 0 14.018 13.003">
                                <path id="Rectángulo_9" data-name="Rectángulo 9"
                                                    d="M304.98,386.9s1.489,1.413,3.5,3.546c4.553-2.794,10.514-9.457,10.514-9.457l-10.514,13Z"
                                                    transform="translate(-304.98 -380.994)" fill="#fff" />
                              </svg>
                            </span>
                          </label>
                      </div>
                </div>
            </div>
            <button class="button alternative fluid" @click="() => {exportCSV()}">Generar Archivo</button>
          </div>
        </div>
      </div>
</template>

<script>
export default {
    name:"exportFile",
    props:['isActive','nombre'],
    data() {
        return {
            fName:'',
            resumen : false
        }
    },
    destroyed(){
      this.fName = '';
      this.resumen = false;
    },
    beforeMount(){
      if(this.nombre)
        this.fName = this.nombre;
    },
    watch:{
      nombre(){
        if(this.nombre)
          this.fName = this.nombre;
      }
    },
    methods:{
        closeModal(){
            this.fName = '';
            this.$emit('closeModal')
        },
        exportCSV(){
          let conf = {
            fName : this.fName,
            fRes: this.resumen
          }
          this.$emit('exportCSV',conf)
        }
    }
}
</script>

<style scoped>
.fName{
    width:100%;
    border-radius: 5px;
    color: #062633;
}
</style>